import { shuffle } from "./helper"

/**
 * 
 * @param {int} length 
 * @param {string} optional user or item
 */
export const GEmot = (length, optional) => {
    const emoji_user_array = ["😀", "😁", "😂", "🤣", "😃", "😄", "😅", "😆", "😉", "😊", "😎", "😋", "😍", "😘", "🥰", "😗", "😙", "🥲", "😚", "☺️", "🙂", "🤗", "🤩", "🤔", "🫡", "🤨", "😐", "😑", "😶", "🫥", "😶‍🌫️", "🙄", "😏", "😣", "😮", "😥", "🤐", "😯", "😪", "😫", '🥱', "😴", "😌", "😛", "😜", "😝", "🤤", "😒", "😓", "😔", "😕", "🫤", "🙃", "🫠", "🤑", "😲", "☹️", "🙁", "😖", "😞", "😟", "😤", "😢", "😭", "😦", "😧", "😨", "😩", "🤯", "😬", "😮‍💨", "😰", "😱", "🥵", "🥶", "😳", "🤪", "😵", "😵‍💫", "🥴", "😠", "😡", "🤬", "😷", "🤒", "🤕", "🤢", "🤮", "🤧", "😇", "🥳", "🥸", "🥺", "🥹", "🤠", "🤡", "🤥", "🫨", "🙂‍↔️", "🙂‍↕️", "🤫", "🤭", "🫢", "🫣", "🧐", "🤓"]

    const emoji_item_array = ["👢", "🪮", "🩰", "👑", "🧢", "🪖", "⛑️", "👒", "🎩", "🎓", "💋", "💄", "💍", "💎", "⚽", "⚾", "🥎", "🏀", "🏐", "🏈", "🏉", "🎱", "🎳", "🥌", "⛳", "⛸️", "🎣", "🤿", "🎽", "🛶", "🎿", "🛷", "🥅", "🏒", "🥍", "🏏", "🏑", "🏓", "🏸", "🎾", "🥏", "🪁", "🎯", "🥊", "🥋", "🥇", "🥈", "🥉", "🏅", "🎖️", "🏆", "🎮", "🕹️", "🎰", "🎲", "🔮", "🪄", "🧿", "🪬", "🧩", "🧸", "🪅", , "🪩", "🪆", "🪀", "🎴", "🃏", "🀄", "♟️", "♠️", "♣️", "♥️", "♦️", "🔈", "🔉", "🔊", "📢", "📣", "🔔", "🎼", "🎵", "🎶", "🎙️", "🎤", "🎚️", "🎛️", "🎧", "📯", "🥁", "🪘", "🪇", "🪈", "🎷", "🪗", "🎺", "🎸", "🪕", "🎻", "🎹", "📻", "🪓", "🔨", "⛏️", "⚒️", "🛠️", "🔧", "🪛", "🔩"]

    switch (optional) {
        case "user":
            return shuffle(emoji_user_array).slice(0, length + 1)
        case "item":
            return shuffle(emoji_item_array).slice(0, length + 1)
    }
}